/* src/app/quickbooks/send-invoice/send-invoice-filter/send-invoice-filter.component.scss */
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-top: 0.5rem;
}
/*# sourceMappingURL=send-invoice-filter.component.css.map */
